var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.032,
    height: 17.031,
    viewBox: "0 0 17.032 17.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.538,
    y1: -0.387,
    x2: 0.945,
    y2: 0.956,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "telephone-fill_1_",
    "data-name": "telephone-fill (1)",
    d: "M14.115.511A1.745,1.745,0,0,0,11.5.674L9.71,2.98a1.744,1.744,0,0,0-.315,1.494l.547,2.19a.678.678,0,0,1-.178.643L7.307,9.764a.678.678,0,0,1-.644.178L4.474,9.395A1.745,1.745,0,0,0,2.98,9.71L.674,11.5a1.745,1.745,0,0,0-.163,2.611l1.034,1.034a2.777,2.777,0,0,0,2.877.7,18.634,18.634,0,0,0,7.01-4.42,18.634,18.634,0,0,0,4.42-7.009,2.78,2.78,0,0,0-.7-2.877Z",
    transform: "translate(0.501 0.5)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fd62da944090a8a58daf41b3fbe1962e.svg";
export { ForwardRef as ReactComponent };